import { TextSpan } from "components/text-label";
import type { Variant } from "features/daily-delivery/types";
import { getVariantColor } from "features/daily-delivery/utils";
import { CardDockCapacityIndicator } from "./styled";

interface CardProps {
  variant: Variant;
  totalExpected: number;
  capacity?: number;
}

export const DockCapacityIndicator = (props: CardProps) => {
  const { variant, capacity, totalExpected } = props;

  return (
    <CardDockCapacityIndicator>
      <TextSpan
        color={getVariantColor(variant)}
        display="block"
        style={{ fontSize: "24px", fontWeight: 600, lineHeight: "150%" }}
      >
        {totalExpected}
      </TextSpan>

      <TextSpan
        color={getVariantColor(!capacity || capacity === 0 ? undefined : variant)}
        display="block"
        style={{ fontSize: "24px", fontWeight: 600, lineHeight: "150%" }}
      >
        {`/${capacity ?? "-"}`}
      </TextSpan>
    </CardDockCapacityIndicator>
  );
};
